import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Loading } from '../components/Loading';
import ServiceCalls from '../utils/serviceCalls.js';
import RoleUtils from '../utils/roleUtils';
import CommonUtils from '../utils/siteUtils';
import '../styles/Home.css';

export class GlobalInbox extends Component {

    constructor(props) {
        super(props);
        this.onWidgetRender = this.onWidgetRender.bind(this);
        this.initializeWidget = this.initializeWidget.bind(this);
        this.startCountdown = this.startCountdown.bind(this);
        this.state = {
            compose: false,
            hasAccess: false,
            msgWidget: null,
            mailbox: null,
            recipients: null,
            environmentUrl: null,
            environment: null,
            tokenUrl: null,
            omsToken: '',
            isLoading: true,
            widgetRendered: false,
            inboxCount: null,
            inboxView: null,
            replyOpened: false,
            hasMailError: false,
            tokenRefreshAttempted: false,
            timeLeftMinutes: null
        };
        this.countdownTimerId = null;

    }

    componentDidMount() {
        // Set hash to inbox to trigger widget load on mount
        //NEW OMS - NOT USED
        window.location.hash = "/secure-messaging";
        const { currentUser, currentCompanyId } = this.props;
        const { widgetProps } = this.props.omsObj;
        ServiceCalls.checkSupplierAccess(currentCompanyId).then(function (data) {
            if (data) {
                var hasCorrectRole = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allPerms());
                console.log(`Fresh User has corret role: ${hasCorrectRole}`);
                var widgetStatus = this.props.omsObj.hasRendered;
                var widgetError = this.checkOMSError(this.props.omsObj);
                var omsToken = (widgetStatus) ? (widgetProps.omsToken.access_token) ? widgetProps.omsToken.access_token : widgetProps.omsToken.omsToken.access_token : '';
                this.setState({
                    widgetRendered: widgetStatus,
                    isLoading: false,
                    hasAccess: (data === false) ? false : (hasCorrectRole),
                    hasMailError: widgetError,
                    omsToken: omsToken
                });

                if (widgetProps.mailbox && widgetStatus && omsToken) {
                    this.initializeWidget(omsToken);
                }

            }
            else {
                this.setState({ hasAccess: false, isLoading: false });
            }
        }.bind(this));
    }
    componentDidUpdate(prevProps, prevState) {
        const { currentUser, currentCompanyId } = this.props;
        const { widgetProps } = this.props.omsObj;
        if (
            (prevProps.currentCompanyId !== currentCompanyId) ||
            (this.props.omsObj.hasRendered &&
                (JSON.stringify(this.props.omsObj) !== JSON.stringify(prevProps.omsObj)))
        ) {
            console.log('Updating component');
            ServiceCalls.checkSupplierAccess(currentCompanyId).then(function (data) {
                if (data) {
                    var hasCorrectRole = RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.allPerms());

                    var widgetStatus = this.props.omsObj.hasRendered;
                    var widgetError = this.checkOMSError(this.props.omsObj);
                    var omsToken = (widgetStatus) ? widgetProps.omsToken.omsToken.access_token : '';
                    var signOnTime = (widgetStatus) ? widgetProps.omsToken.signOnTime : new Date();
                    console.log(`In componentDidUpdate - sign on time from props is: ${signOnTime}`);

                    this.setState({
                        widgetRendered: widgetStatus,
                        isLoading: false,
                        hasAccess: (data === false) ? false : (hasCorrectRole),
                        hasMailError: widgetError,
                        omsToken: omsToken,
                        signOnTime: signOnTime
                    }, () => this.startCountdown(signOnTime));

                    if (widgetProps.mailbox && widgetStatus && omsToken) {
                        this.initializeWidget(omsToken);
                    }

                    if (prevState.signOnTime !== signOnTime) {
                        this.startCountdown(signOnTime);
                    }
                }
                else {
                    this.setState({ hasAccess: false, isLoading: false });
                }
            }.bind(this));
        }
        else if (prevProps.omsObj.widgetProps.mailbox !== widgetProps.mailbox) {
            console.log('Mailbox info updated in props - re-initializing widget with new mailbox info and token');
            //this.initializeWidget();
        }

    }
    componentWillUnmount() {
        if (this.countdownTimerId) {
            clearInterval(this.countdownTimerId);
            this.countdownTimerId = null;
        }
       

        //var widgets = document.getElementsByClassName('content-wrapper');
        //if (widgets) {
        //    while (widgets[0]) {
        //        var remWidget = widgets[0].parentNode.removeChild(widgets[0]);
        //        console.log(`Removing Content DIV ${remWidget.id}`);
        //    }
        //}
    }
    onWidgetRender(inboxView) {
        // eslint-disable-next-line no-unused-vars
        var pid = setTimeout(() => {
            var widgetError = this.checkOMSError(this.props.omsObj);
            this.setState({
                widgetRendered: true,
                inboxView: inboxView,
                hasMailError: widgetError
            });
        }, 800);
    }

    showStatus(msg, isError) {
        //DISPLAY is only needed to have a display 
        if (msg && !isError) {
            console.log(`SM Error: ${msg}`);
        }
        else {
            console.log('Show general SM error message');
            this.setState({
                hasMailError: true,
                mailErrorMsg: msg
            });
        }
    }

    initializeWidget(omsToken) {
        // NEW OMS UI Change
        const PORTAL = 'pssp';
        const IDP = 'onehealthcareid';
        const { widgetProps } = this.props.omsObj;
        console.log(`In global inbox - SMUI Loader for OMS Widget with env URL: ${widgetProps.environmentUrl}`);

        var SECURE_MESSAGE_CONFIG_URL = `${widgetProps.environmentUrl}/${PORTAL}`;
        // Only include values that must be set per-member at runtime.
        // Everything else (baseURL, contentUrl, brand, idp, allowCompose, spaceIdList etc.)
        // comes automatically from the MongoDB portal config the SM team set up.
        //
        if (widgetProps.mailbox) {
            var curSup = CommonUtils.getCurrentSupplier(this.props.currentCompanyId, this.props.currentUser);
            var smConfig = {
                spaceIdList: [widgetProps.mailbox.space_id.toString()],       // member-specific space IDs from your auth/mailbox response

                allowCompose: true,    // override allowCompose from MongoDB
                allowReply: true,      // override allowReply from MongoDB
                // topicId: '',            // routing topic if your portal uses one
                // allowCustomFolders: false,
                // allowMoveToFolder: false,
                messageMetadata: [      // key/value pairs surfaced in compose form
                    { key: 'SetID', value: (curSup) ? curSup.vendorSetId : '' },
                    { key: 'Supplier_ID', value: (curSup) ? curSup.vendorId : '' },
                    { key: 'Supplier_Name', value: (curSup) ? curSup.supplierName : '' },
                    { key: 'Contact', value: (this.props.currentUser) ? this.props.currentUser.email.toString() : '' }
                ]
            };

            if (window.secureMessage && typeof window.secureMessage.sminitialize === 'function') {
                this.showStatus('In global inbox -Initializing widget — fetching portal config from facade...', false);

                // sminitialize is async — it fetches config from the SM Facade then mounts the widget.
                // .catch() is required to surface any errors (bad token, portal not found, CORS etc.)
                window.secureMessage.sminitialize({
                    // URL for SMUI to fetch portal config (uses Authorization: Bearer + X-IDP headers)
                    secureMessageConfigUrl: SECURE_MESSAGE_CONFIG_URL,

                    // Member OIDC JWT — sent as Authorization: Bearer {token} to facade
                    token: omsToken,

                    // IDP — sent as X-IDP header to facade
                    idp: IDP,
                    idpType: IDP,       // backwards-compatible alias — SMUI accepts either key

                    brand: 'optum',
                    language: 'en',

                    // Runtime overrides merged on top of MongoDB portal config
                    smConfig: smConfig,
                    smconfig: smConfig, // backwards-compatible alias

                    // id of the div SMUI will mount the widget into
                    // ⚠ Without this, SMUI creates a NEW div appended to <body> instead of using yours
                    containerId: 'smContainer',

                }).then(() => {
                    this.showStatus('Widget ready. Click "Load Secure Messaging" above to open it.', false);
                }).catch((err) => {
                    const errMsg = err && err.message ? err.message : String(err);

                    if (errMsg.includes('Invalid Token')) {
                        console.log(`OMS Token expired.  Need to sign off to refresh.`);
                        this.showStatus(
                            <p>There is a temporary issue loading your secure mailbox. Please <span className="empWord">log out</span>, close browser, and log back in to resolve.</p>,
                            true
                        );
                    }
                    else {
                        this.showStatus(
                            <p>General Network Error with Secure Messaging. Please <span className="empWord">log out</span>, close browser, and log back in to resolve.</p>,
                            true);
                    }
                });

            }
            else {
                this.showStatus(
                    'window.secureMessage.sminitialize not found. Is the SMUI bundle loaded? Check the <script> src in <head>.',
                    false
                );
            }
        }
        else {
            console.log('No mailbox info yet — widget will be initialized once mailbox is created and token is available');
        }
    }


    startCountdown(signOnTime) {
        if (!signOnTime) return;

        if (this.countdownTimerId) {
            clearInterval(this.countdownTimerId);
        }
 

        const endTime = new Date(signOnTime).getTime() + (30 * 60 * 1000);
        const remainingMs = endTime - Date.now();
        const remainingMinutes = Math.max(0, Math.ceil(remainingMs / 60000));

        const showCounterMessage = (timeLeft) => {
            //Show Counter
            var omsContatiner = document.getElementsByClassName('omsMessageArea');
            try {
                if (omsContatiner && omsContatiner.length > 0) {
                    var minMsg = (timeLeft === 1) ? 'minute' : 'minutes';
                    var counterMsgHtml = `<div className="omsCounterMsg">`;
                    counterMsgHtml += `This page times out every 30 minutes. <strong>${timeLeft ?? 30}</strong> ${minMsg} remaining.`;
                    counterMsgHtml += ` To continue using messaging after time expires, please sign out and sign back in.`;
                    counterMsgHtml += `</div>`;
                    omsContatiner[0].innerHTML = counterMsgHtml;
                }
                else {
                    console.log('OMS Container not loaded yet');
                }
            } catch (e) {
                console.log('Error in OMS Container ', e);
            }
        };
        const updateCountdown = () => {
            const signOnTime = this.state.signOnTime;
            const endTime = new Date(signOnTime).getTime() + (30 * 60 * 1000);
            const remainingMs = endTime - Date.now();
            const remainingMinutes = Math.max(0, Math.ceil(remainingMs / 60000));
            console.log(`Setting End minutes to: ${remainingMinutes} from End time: ${endTime}`);
            this.setState({ timeLeftMinutes: remainingMinutes });
            showCounterMessage(remainingMinutes);
        };


        updateCountdown();
        showCounterMessage(remainingMinutes);
        this.countdownTimerId = setInterval(updateCountdown, 60000);
      //  this.messageTimerId = setInterval(() => showCounterMessage(remainingMinutes), 60000);

    }

    checkOMSError(omsObj) {
        if (omsObj.msgWidget) {
            if (omsObj.msgWidget.dataStores) {
                if (omsObj.msgWidget.dataStores.messagesStore.errorsStore) {
                    // Prevent errors from displaying  use: 
                    return false;
                    //Show custom OMS errors use:
                    //return (omsObj.msgWidget.dataStores.messagesStore.errorsStore.length > 0);
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        else { return false; }
    }


    //NEW OMS - NOT USED
    render() {
        const { isLoading, hasAccess, hasMailError, mailErrorMsg, timeLeftMinutes } = this.state;

        if (isLoading) {
            return <div style={{ marginTop: '30px' }}><Loading /></div>;
        }
        if (!hasAccess) {
            return <h3 style={{ marginTop: "10px" }}>You do not have access rights to this page.</h3>;
        }
        if (hasMailError) {
            return (
                <div id="inboxPage">
                    <span className="omsWarning noOMSError">
                        {mailErrorMsg}
                    </span>
                </div>
            );
        }
        else {

            return (
                <Container id="inboxPage" fluid>
                    <Row>
                        <Col className='omsMessageArea'></Col>
                    </Row>
                    <Row>
                        <Col id='smContainer'></Col>
                    </Row>
                    {/* ONLY NEEDED FOR DEBUGGING */}
                    {/* <Row>*/}
                    {/*    <Col id='sm-status'></Col>*/}
                    {/*</Row>*/}
                </Container>
            );
        }
    }
}